import ls from 'local-storage';
import { COMMON_LOCAL_STORAGE_CACHE_KEY } from '../constants/localStorageConstants';
import { validateDateIsAfterToday } from '../utils/dateUtils';
import { setRequestAction } from '../ducks/requestDuck';

const loadCommonCacheThunk = (taxonomy = '') => (dispatch) => {
  const commonCache = ls.get(COMMON_LOCAL_STORAGE_CACHE_KEY);
  if (!commonCache || taxonomy === 'FHR' || taxonomy === 'THC') {
    return;
  }
  const {
    startDate,
    endDate,
    to,
  } = commonCache;

  dispatch(
    setRequestAction(
      {
        startDate: validateDateIsAfterToday(startDate),
        endDate: validateDateIsAfterToday(endDate),
        ...to && {
          location: {
            id: to?.id,
            name: to?.name,
            label: to?.label,
            airportCode: to?.airportCode,
            type: to?.type,
          },
        },
      }
    )
  );
};

export default loadCommonCacheThunk;
